const accordion = () => {
	const $accordion = $('.js-accordion');

	$accordion.on('click', '.accordion__item-head', function(event) {
		event.preventDefault();

		const $this = $(this);
		const toggleIsActive = $this.closest('.js-accordion').hasClass('js-accordion-toggle');

		if (toggleIsActive) {
			$this
			.next()
			.stop()
			.slideToggle(400)
			.parent()
			.toggleClass('is-expanded')
			.siblings()
			.removeClass('is-expanded');
		}

		if (!toggleIsActive) {
			$this
			.parent()
			.toggleClass('is-expanded')
			.siblings()
			.removeClass('is-expanded');
		}
	});
};

accordion();

const handleAccordionSecondary = () => {
	const $accordion = $('.js-accordion-secondary');

	if( !$accordion.length ) {
		return;
	}

	$accordion.find('.accordion__section').each(function(index, el) {
		const $this = $(this);

		if (! $this.hasClass('is-open')) {
			$this.find('.accordion__body').slideUp();
		}
	});

	$accordion.on('click', '.accordion__head h2', function () {
		const $this = $(this);
		const $section = $this.closest('.accordion__section');
		const $body = $section.find('.accordion__body');

		$section.toggleClass('is-open');

		$body.slideToggle();
	})
}

handleAccordionSecondary();

const handleTabsMobileAccordion = () => {
	const $tabTrigger = $('.product__tab-btn');

	$('.product__tab-entry').hide();

	$('.product__tab.is-current .product__tab-entry').show();

	$tabTrigger.on('click', function(event) {
		const $this = $(this);
		const $parent = $this.closest('.product__tab');

		$this.siblings('.product__tab-entry').slideToggle();

		$parent.toggleClass('is-current')
			.siblings()
			.removeClass('is-current')
			.find('.product__tab-entry')
			.slideUp();

		event.preventDefault();
	});
}

handleTabsMobileAccordion();
